<template>
    <div class="unilateralConsumption">
        <div class="search-conditions-con">
            <div class="search-conditions">
                <span class="time-con" @click="showCalendarPop=true">
                    <span>{{ date }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
        </div>

        <div class="main">
            <div class="top" v-if="materialcategory.length>0">
                <div class="title">
                    <span class="van_right">
                        单位：(千克/方)
                    </span>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>原材料类型</th>
                            <th>配比用量</th>
                            <th>实际消耗</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            @click="selectRow(item, index)"
                            v-for="(item, index) in materialcategory"
                            :key="index"
                            :class="{'activeRow': activeRow === index}"
                        >
                            <td class="row-tit">
                                {{ item.name }}
                            </td>
                            <td>{{ item.formula_value }}</td>
                            <td>{{ item.actual_value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="chart-con" v-if="materialcategory.length>0">
                <h4>按标号</h4>
                <template>
                    <div
                        id="lineChart"
                        class="lineChart"
                    ></div>
                </template>
            </div>
            <div class="chart-con" v-show="material_category_code">
                <h4>按企业</h4>
                <template>
                    <div
                        id="lineChart2"
                        class="lineChart"
                    ></div>
                </template>
            </div>
            <div class="empty-data" v-if="!materialcategory.length>0||!material_category_code">
                暂无数据
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            // 选择时间
            showCalendarPop: false,
            // 选择组织结构
            showOrgPop: false,
            // 当前日期
            date: '',
            endTime: '',
            // 选中场站
            orgName: '全部',
            columns: [
                {
                    text: '全部',
                }, {
                    text: '济宁',
                }, {
                    text: '青州',
                }, {
                    text: '东营',
                },
            ],
            // 场站
            stationData: [
                { station_id: 'T200103000002', name: '青州' },
                { station_id: 'T200103000003', name: '东营' },
                { station_id: 'T200103000004', name: '济宁' },
            ],
            // 选中场站code
            stationId: '',

            currentDate: new Date(),
            // 选中表格行index
            activeRow: 0,
            // 原料分类汇总数据
            materialcategory: [],
            // 选中原材料场站编码
            material_category_code: '',
            // 按标号统计
            gradeData: {
                xData: [],
                theory_volume: [],
                actual_value: [],
                consume: [],
            },
        };
    },
    props: {
        filterData: Object,
    },
    watch: {
        filterData() {
            this.getData();
        },
    },
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 初始化页面
        init() {
            const date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            let endMonth = date.getMonth() + 2;
            endMonth = endMonth < 10 ? '0' + endMonth : endMonth;
            if (endMonth > 12) {
                endMonth = 1;
                year = year + 1;
            }
            this.date = year + '-' + month;
            this.endTime = year + '-' + endMonth;

            this.getData();
        },
        // 获取数据
        async getData() {
            this.materialcategory = await this.getConsumeByType(this.date, this.stationId);
            if ((this.materialcategory || []).length > 0) {
                this.material_category_code = this.materialcategory[0].code;
                if (this.material_category_code) {
                    this.handleStatisticalstrengthgrade();
                    this.initChartByCompany();
                }
            } else {
                this.materialcategory = [];
                this.material_category_code = '';
            }
        },
        // 拉取场站
        getStation() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationData.push(...stationList);
                this.columns = this.stationOriginal.map(item => {
                    return { text: item.name };
                });
            }
        },
        // 按标号
        async handleStatisticalstrengthgrade() {
            const data = await this.getConsumeByCpbh(this.material_category_code, this.date, this.stationId);
            if (data) {
                this.gradeData = {
                    xData: [],
                    theory_volume: [],
                    actual_value: [],
                };
                data.map(item => {
                    this.gradeData.xData.push(item.name);
                    this.gradeData.theory_volume.push(item.formula_value);
                    this.gradeData.actual_value.push(item.actual_value);
                });
                this.initGradeChart();
            }
        },

        // 选中日期
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = this.formatDate(value);
            this.endTime = this.formatDate(value, 'end');
            this.getData();
        },
        // 取消选中日期
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 格式化日期
        formatDate(date, type) {
            date = new Date(date);
            let y = date.getFullYear();
            let m;
            if (type === 'end') {
                m = date.getMonth() + 2;
                if (m > 12) {
                    m = 1;
                    y = y + 1;
                }
            } else {
                m = date.getMonth() + 1;
            }
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        // 场站确认选择
        confirmOrg(value) {
            this.showOrgPop = false;
            this.orgName = value.text;
            this.stationData.map(item => {
                if (item.name === value.text) {
                    this.stationId = item.station_id;
                }
            });
            if (value.text === '全部') {
                this.stationId = '';
            }
            this.getData();
        },
        // 场站取消选择
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 选中table行
        selectRow(item, index) {
            this.material_category_code = item.code;
            this.activeRow = index;
            this.handleStatisticalstrengthgrade();
            this.initChartByCompany();
        },
        // 安标号
        initGradeChart() {
            const myChart = this.$echarts.init(document.getElementById('lineChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    left: 30,
                },
                legend: {
                    data: ['配比用量', '实际消耗'],
                },
                dataZoom: {
                    type: 'inside',
                    startValue: 0,
                    endValue: 8,
                    zoomLock: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.gradeData.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(千克/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '配比用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(113,198,176,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(78,164,150,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.theory_volume,
                    },
                    {
                        name: '实际消耗',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(242,227,65,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(220,193,41,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.actual_value,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        // 按企业统计
        async initChartByCompany() {
            const data = await this.getConsumeBytenant(this.material_category_code, this.date, this.stationId);
            const xData = [];
            const formula_value = [];
            const actual_value = [];
            const lineArr = [];
            if (data) {
                data.map(item => {
                    xData.push(item.name);
                    formula_value.push(item.formula_value);
                    actual_value.push(item.actual_value);
                    lineArr.push(item.formula_value > item.actual_value ? item.formula_value : item.actual_value);
                });
            }
            const myChart = this.$echarts.init(document.getElementById('lineChart2'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                legend: {
                    right: '50',
                    data: ['配比用量', '实际消耗'],
                },
                grid: {
                    top: '50',
                    left: '35',
                    right: '20',
                    bottom: '20',
                },
                dataZoom: {
                    type: 'inside',
                    startValue: 0,
                    endValue: 4,
                    zoomLock: true,
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: '#979EA7',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                        },
                    },
                    splitLine: {
                        // 坐标轴在 grid 区域中的分隔线。
                        show: false,
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '(千克/方)',
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        textStyle: {
                            color: '#979EA7',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 12,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                        },
                    },
                },
                series: [
                    {
                        name: '配比用量',
                        type: 'bar',
                        data: formula_value,
                        barWidth: '18',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#55A7FE' },
                                        { offset: 1, color: '#3E79C5' },
                                    ]
                                ),
                                label: {
                                    show: false,
                                    position: 'top',
                                    textStyle: {
                                        color: '#DCC229',
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                    },
                    {
                        name: '实际消耗',
                        type: 'bar',
                        data: actual_value,
                        barWidth: '18',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#EFAB54' },
                                        { offset: 1, color: '#FA8C47' },
                                    ]
                                ),
                                label: {
                                    show: false,
                                    position: 'top',
                                    textStyle: {
                                        color: '#478BDB',
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                    },
                    {
                        type: 'pictorialBar',
                        itemStyle: {
                            normal: {
                                color: '#fff',
                            },
                        },
                        tooltip: {
                            show: false,
                        },
                        symbolRepeat: 'fixed',
                        symbolMargin: 2,
                        symbol: 'rect',
                        symbolClip: true,
                        symbolSize: [60, 2],
                        symbolPosition: 'start',
                        symbolOffset: [0, 6],
                        z: 3,
                        animationEasing: 'elasticOut',
                        data: lineArr,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        // 按材料类型分组
        getConsumeByType(date, tenant_id) {
            const data = {
                tenantId: tenant_id,
                date: date,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            return this.$axios
                .post('/interfaceApi/report/consume/material/consume/type', data);
        },
        // 按产品编号分组获取数据
        getConsumeByCpbh(type_code, date, tenant_id) {
            const data = {
                tenantId: tenant_id,
                date: date,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            return this.$axios.post(`/interfaceApi/report/consume/material/consume/cpbh/${type_code}`, data);
        },
        // 按租户分组获取数据
        getConsumeBytenant(type_code, date, tenant_id) {
            const data = {
                tenantId: tenant_id,
                date: date,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            return this.$axios.post(`/interfaceApi/report/consume/material/consume/tenant/${type_code}`, data);
        },
    },
};
</script>
<style lang="stylus" scoped>
.unilateralConsumption
    width 100%
    height 100%
    .search-conditions-con
        background #fff
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                position relative
                flex 1
                text-align center
                &:after
                    content ''
                    position absolute
                    right 10rpx
                    height 15rpx
                    border-right 1px solid #D7D7D7
                    margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                flex 1
                text-align center
                .org-name
                    color #3495FB
    .main
        margin-top 15rpx;
        .top
            border-top: 15rpx solid #f0f0f0;
            padding 10rpx
            .title
                height 16rpx
                overflow hidden
                margin-bottom 8rpx
                h4
                    font-size 16rpx
                    line-height 16rpx
                    color #333333
                span
                    font-size 12rpx
                    height 16rpx
                    line-height 16rpx
                    color #979EA7
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                table-layout fixed
                th
                    background rgba(235,240,252,1)
                    height 45rpx
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    font-size 14rpx
                    font-weight normal
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 30rpx
                    text-align center
                    font-size 14rpx
                    background rgba(85,136,241,.04)
                    width 25%
                    color #5588F1
                    &.row-tit
                        color #333333
                        background rgba(235,240,252,1)
                tbody
                    tr
                        &.activeRow
                            td
                                background rgba(250,132,54,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                color #fff
                            .row-tit
                                color #823802
                                background rgba(245,242,237,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                border 1px solid rgba(222,227,239,1)
        .empty-data
            font-size 28rpx
            line-height 200rpx
            text-align center
            color #ccc
        .chart-con
            border-top: 15rpx solid #f0f0f0;
            background #fff
            padding 10rpx
            h4
                font-size 16rpx
            .lineChart
                width 95%
                margin-left 5%
                height 235rpx
            h5
                text-align center
                margin-top 20rpx
</style>
